import Money from "~/models/Money";

export default class PlagiarismBundle {

  private readonly _size;
  private readonly _bundlePricePerCheck;
  private readonly _discountPercentage;
  private readonly _bundlePrice;

  constructor({
      size,
      bundlePricePerCheck,
      discountPercentage,
      bundlePrice
  }) {
    this._size = size;
    this._bundlePricePerCheck = new Money(bundlePricePerCheck);
    this._discountPercentage = discountPercentage;
    this._bundlePrice = new Money(bundlePrice);
  }

  get size() {
    return this._size;
  }

  get bundlePricePerCheck() {
    return this._bundlePricePerCheck;
  }

  get discountPercentage() {
    return this._discountPercentage;
  }

  get bundlePrice() {
    return this._bundlePrice;
  }
}
